"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDeviceDetect = require("react-device-detect");

var _option = _interopRequireDefault(require("./option"));

require("../../css/shared/options_list.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OptionsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OptionsList, _React$Component);

  function OptionsList(props) {
    var _this;

    _classCallCheck(this, OptionsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionsList).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "calcBorderBottomWidth", function () {
      var _this$props = _this.props,
          onAction = _this$props.onAction,
          options = _this$props.options,
          visibleOptions = _this$props.visibleOptions;
      var optionsLength = onAction ? options.length + 1 : options.length;
      var isScroll = visibleOptions < optionsLength;

      if (_this.optionsList && isScroll) {
        var scrollBarWidth = _this.optionsList.offsetWidth - _this.optionsList.clientWidth;
        var borderBottomWidthStyle = {
          '--border-bottom-width': "calc(100% - ".concat(scrollBarWidth, "px)")
        };

        _this.setState({
          borderBottomWidthStyle: borderBottomWidthStyle
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "calcOptionsHeight", function () {
      var _this$props2 = _this.props,
          onAction = _this$props2.onAction,
          options = _this$props2.options,
          visibleOptions = _this$props2.visibleOptions;
      var optionsLength = onAction ? options.length + 1 : options.length;
      var optionHeight = 34;
      var borderHeight = 3; // height of .vn-options-list__scroll::after

      var halfOption = optionHeight / 2 + borderHeight;
      var maxOptions = optionsLength;

      if (visibleOptions >= maxOptions || visibleOptions <= 0) {
        return maxOptions * optionHeight;
      }

      return visibleOptions * optionHeight + halfOption;
    });

    _this.state = {
      borderBottomWidthStyle: null
    };
    return _this;
  }

  _createClass(OptionsList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calcBorderBottomWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          action = _this$props3.action,
          highlightedIndex = _this$props3.highlightedIndex,
          highlightedRef = _this$props3.highlightedRef,
          multiple = _this$props3.multiple,
          onAction = _this$props3.onAction,
          onClick = _this$props3.onClick,
          onKeyDown = _this$props3.onKeyDown,
          onKeyPress = _this$props3.onKeyPress,
          onMouseDown = _this$props3.onMouseDown,
          onMouseMove = _this$props3.onMouseMove,
          _onScroll = _this$props3.onScroll,
          options = _this$props3.options,
          selectedIndex = _this$props3.selectedIndex,
          typedText = _this$props3.typedText,
          value = _this$props3.value,
          visibleOptions = _this$props3.visibleOptions;
      var borderBottomWidthStyle = this.state.borderBottomWidthStyle;
      var optionsLength = onAction ? options.length + 1 : options.length;
      var isScroll = visibleOptions < optionsLength;
      var listClasses = {
        'vn-options-list': true,
        'vn-options-list__scroll': isScroll,
        'vn-options-list__scroll--ie': isScroll && _reactDeviceDetect.isIE
      };
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(listClasses),
        onScroll: function onScroll(e) {
          return _onScroll(e);
        },
        ref: function ref(el) {
          _this2.optionsList = el;
        },
        role: "listbox",
        style: _objectSpread({
          height: "".concat(this.calcOptionsHeight(), "px")
        }, borderBottomWidthStyle)
      }, onAction && _react.default.createElement(_option.default, {
        action: action,
        isHighlighted: highlightedIndex === 0,
        isSelected: selectedIndex === 0,
        key: "action",
        onAction: onAction,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onMouseMove: onMouseMove,
        option: {
          value: typedText
        }
      }), options.map(function (option, index) {
        return _react.default.createElement(_option.default, {
          highlightedRef: highlightedRef,
          isHighlighted: onAction ? highlightedIndex === index + 1 : highlightedIndex === index,
          isSelected: onAction ? selectedIndex === index + 1 : value.length > 0 && value.includes(option.value),
          key: option.value,
          multiple: multiple,
          onClick: onClick,
          onKeyDown: onKeyDown,
          onKeyPress: onKeyPress,
          onMouseDown: onMouseDown,
          onMouseMove: onMouseMove,
          option: option
        });
      }));
    }
  }]);

  return OptionsList;
}(_react.default.Component);

OptionsList.propTypes = {
  action: _propTypes.default.string,
  highlightedIndex: _propTypes.default.number,
  highlightedRef: _propTypes.default.func,
  multiple: _propTypes.default.bool,
  onAction: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseMove: _propTypes.default.func,
  onScroll: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    disabled: _propTypes.default.bool,
    flag: _propTypes.default.string,
    icon: _propTypes.default.string,
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
  })).isRequired,
  selectedIndex: _propTypes.default.number,
  typedText: _propTypes.default.string,
  value: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])),
  visibleOptions: _propTypes.default.number
};
OptionsList.defaultProps = {
  action: 'Create New',
  highlightedIndex: undefined,
  highlightedRef: function highlightedRef() {},
  multiple: false,
  onAction: null,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onMouseDown: function onMouseDown() {},
  onMouseMove: function onMouseMove() {},
  onScroll: function onScroll() {},
  selectedIndex: undefined,
  typedText: '',
  value: [],
  visibleOptions: 10
};
var _default = OptionsList;
exports.default = _default;